import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';

import { Store } from '@ngrx/store';
import * as ReportingActions from '@reporting/reporting.actions';

@Component({
  selector: 'app-exit-survey-modal',
  templateUrl: './exit-survey.component.html',
  standalone: false
})
export class ExitSurveyComponent {
  constructor(
    public http: HttpClient,
    private store: Store
  ) {}

  continue(): void {
    this.store.dispatch(ReportingActions.updateSuperhumanExitSurvey({ value: false }));
    this.store.dispatch(ReportingActions.showSuperhumanExitModal({ show: false }));
  }

  exit(): void {
    this.store.dispatch(ReportingActions.updateSuperhumanExitSurvey({ value: true }));
    this.store.dispatch(ReportingActions.showSuperhumanExitModal({ show: false }));
  }
}
